import { fetchLocalServices } from './apiClients/LocalhostApi';
import { getSessionStorage } from './apiClients/global';
export const CHIRP_SKIP_LOCAL_KEY = 'CHIRP_SKIP_LOCAL';
export const CHIRP_FORCE_401_KEY = 'CHIRP_FORCE_401';
let localServicesPromise = null;

// we aren't allowed enviro here due to npm-shim constraints
function isQA() {
  try {
    var _window$location$host, _window$location;
    if (typeof window === 'undefined') {
      return false;
    }
    const hostname = (_window$location$host = (_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname) !== null && _window$location$host !== void 0 ? _window$location$host : '';
    return hostname.includes('qa.');
  } catch (_unused) {
    return false;
  }
}
function getSessionStorageFlag(key) {
  const sessionStorage = getSessionStorage();
  if (!sessionStorage || typeof sessionStorage.getItem !== 'function') {
    return false;
  }
  try {
    return sessionStorage.getItem(key) === 'true';
  } catch (_unused2) {
    return false;
  }
}
function shouldSkipLocal() {
  return getSessionStorageFlag(CHIRP_SKIP_LOCAL_KEY);
}
function fetchLocalServicesCached() {
  if (!localServicesPromise) {
    localServicesPromise = fetchLocalServices().catch(() => []);
  }
  return localServicesPromise;
}
export async function resolveLocalRequest(serviceName) {
  if (!isQA()) {
    return false;
  }
  if (shouldSkipLocal()) {
    return false;
  }
  try {
    const services = await fetchLocalServicesCached();
    return services.some(s => s.name === serviceName);
  } catch (_unused3) {
    return false;
  }
}
export function shouldForce401() {
  return getSessionStorageFlag(CHIRP_FORCE_401_KEY);
}